export const SURVEY_CONTACTO = 'UPD_CONTACTO_2025'
export const SURVEY_EMPRESAS_NUEVAS = 'EMPRESAS_NUEVAS_2026'
export const SURVEY_EMPRESAS_NO_NUEVAS = 'EMPRESAS_NO_NUEVAS_2026'

export const surveyHero = {
  [SURVEY_EMPRESAS_NO_NUEVAS]: {
    title: 'Actualización de Contactos – Facturación y Cobranza',
    body1: 'Actualiza los contactos de recepción de facturas y cobranza.',
    body2: 'Te tomará menos de 2 minutos.',
    cta: 'Responder aquí',
  },
  [SURVEY_EMPRESAS_NUEVAS]: {
    title: 'Encuesta Empresas Nuevas amiPASS',
    body1:
      'Conocer la experiencia de las empresas durante sus primeros meses de uso, medir el cumplimiento de la promesa comercial e identificar oportunidades de mejora.',
    body2: '',
    cta: 'Responder aquí',
  },
}

export const exclusiveOptionsByQuestion = {
  P7_SERVICIOS: ['NO_CONOZCO'],
}
